import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute('/(client)/risk/(pages)/(edit)')({
  beforeLoad: async () => {
    const { risk } = await ensurePermissions();
    if (!risk.canEdit) throw redirect({ to: '/risk/rules' });
  },
  component: () => <Outlet />,
});
